/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Settings,
    SettingsFromJSON,
    SettingsToJSON,
    SftpSettingsDTO,
    SftpSettingsDTOFromJSON,
    SftpSettingsDTOToJSON,
} from '../models';

export interface SaveSftpSettingRequest {
    sftpSettingsDTO: SftpSettingsDTO;
}

/**
 * 
 */
export class SettingsApi extends runtime.BaseAPI {

    /**
     */
    async getSettingsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Settings>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SettingsFromJSON(jsonValue));
    }

    /**
     */
    async getSettings(initOverrides?: RequestInit): Promise<Settings> {
        const response = await this.getSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getSftpNamesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/sftpnames`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getSftpNames(initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.getSftpNamesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getSftpSettingsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<SftpSettingsDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/sftpsettings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SftpSettingsDTOFromJSON));
    }

    /**
     */
    async getSftpSettings(initOverrides?: RequestInit): Promise<Array<SftpSettingsDTO>> {
        const response = await this.getSftpSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async saveSftpSettingRaw(requestParameters: SaveSftpSettingRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sftpSettingsDTO === null || requestParameters.sftpSettingsDTO === undefined) {
            throw new runtime.RequiredError('sftpSettingsDTO','Required parameter requestParameters.sftpSettingsDTO was null or undefined when calling saveSftpSetting.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/sftpsetting`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SftpSettingsDTOToJSON(requestParameters.sftpSettingsDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async saveSftpSetting(sftpSettingsDTO: SftpSettingsDTO, initOverrides?: RequestInit): Promise<void> {
        await this.saveSftpSettingRaw({ sftpSettingsDTO: sftpSettingsDTO }, initOverrides);
    }

}
